

import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import config from '../config/config';
import { onGenerateShareUrl, postContext } from '../features/appSlice';
import { useParams } from 'react-router-dom';
import { isValidURL } from '../helper/helper';
import Modal from '../ui/modal/Modal';
const options = [
    // { id: 1, name: "AI Onboarding" },
    { id: 1, name: "Plumbing / HVAC" },
    { id: 2, name: "Dental" },
    { id: 3, name: "Legal" },
];

const TopActionButtonai = (props) => {
    const domainlist = ['dev.zyratalk.com', 'uat.zyratalk.com', 'zyratalk.com', 'www.zyratalk.com', 'localhost'];
    const domaina = !domainlist.includes(window.location.hostname) ? window.location.hostname : config.baseurl;
    const state = useSelector((state) => state);
    const [showAskForModal, setshowAskForModal] = useState(false);
    const [modalBody, setmodalBody] = useState('');
    const [modalFooter, setmodalFooter] = useState('');
    const [modaltitle, setModalTitle] = useState('');
    const [errors, setErrors] = useState('');
    const [modalLoader, setmodalLoader] = useState(false);
    const [path, setPath] = useState('playground');
    const dispacth = useDispatch();
    const urlParameters = useParams();

    const createUrlForPlayground = () => {
        let affiliateid = urlParameters.affiliateid ? urlParameters.affiliateid : '';
        let plid = urlParameters.id ? urlParameters.id : '';
        let urlpath = 'playground';
        if(affiliateid){
            urlpath = `playground/${affiliateid}`;
        }
        if((plid && plid.includes('_'))){
            urlpath = `playground/${plid}`;
        }
        setPath(urlpath);

    }

    useEffect(() => {
        createUrlForPlayground();
    }, [])



    const onSavePlayground = (type) => {
        let statedata = JSON.parse(JSON.stringify(state.app.contextData));

        const newYourFaq = [...statedata?.your_faq]


        let error = [];

        if (error.length) {
            setshowAskForModal(true);
            setModalTitle('Save Playground context');
            setmodalBody(errorSaveBody(error));
            setmodalFooter(errorSaveFooter());
            return;
        }
        if (state.app.isEmailValid) {
            setshowAskForModal(true);
            setModalTitle('Save Playground context');
            setmodalBody(errorSaveBody(error));
            setmodalFooter(errorSaveFooter());
            return;
        }

        // if (type === 'old') {
        //     statedata.playgroundId = state.app.playgroundId;
        // }
        let myform = document.getElementById("editlogoform");
        let formData = new FormData(myform);
        formData.append('about_us', JSON.stringify(statedata.about_us));
        formData.append('additonal_faq_context', statedata.additonal_faq_context);
        formData.append('business_categories', JSON.stringify(statedata.business_categories));
        formData.append('buttonColor', statedata.buttonColor);
        formData.append('buttonHeaderColor', statedata.buttonHeaderColor);
        formData.append('buttonTextColor', statedata.buttonTextColor);
        formData.append('company_information', JSON.stringify(statedata.company_information));
        formData.append('conversation_goal', statedata.conversation_goal.replace(/<br\/>/g, '\n'));
        formData.append('primaryColor', statedata.primaryColor);
        formData.append('secondaryColor', statedata.secondaryColor);
        formData.append('selectedTheme', statedata.selectedTheme);
        // formData.append('your_faq', JSON.stringify(statedata.your_faq));newYourFaq
        if (props?.results) {
            formData.append('your_faq', JSON.stringify(newYourFaq));
        } else {
            formData.append('your_faq', JSON.stringify(statedata.your_faq));
        }
        formData.append('zipcoderules', JSON.stringify(statedata.zipcoderules));
        // formData.append('company_overview', statedata.company_overview);
        formData.append('company_overview', statedata.company_overview || props?.dataUrls || props.dataUrl);
        if (type === 'old') {
            formData.append('playgroundId', state.app.playgroundId);
            formData.append('playgroundUniqueId', state.app.playgroundUniqueId);
        }
        dispacth(postContext(formData));
    }


    const closeModals = () => {
        setshowAskForModal(false);
        setmodalBody('');
        setmodalFooter('');
        setModalTitle('');
    }

    const errorSaveBody = (error) => {
        return (

            <div className='text-center'>
                {error.map((err, mapindexerror) => (
                    <p style={{ color: '#343a40', fontSize: 16 }} key={mapindexerror.toString()} className='fw-bold text-center'>{err.message}</p>
                ))}
            </div>
        )
    }
    const errorSaveFooter = () => {
        return (
            <button
                type="button"
                className="yr-cancelbtn"
                data-dismiss="modal"
                onClick={closeModals}
            >
                <span>Close</span>
            </button>
        )
    }

    const generateShareUrl = () => {
        dispacth(onGenerateShareUrl(true));
        copyUrl();
    }

    const copyUrl = () => {
        // const url = `${domaina}/playground/${state.app.playgroundUniqueId}`;
        const url = `${domaina}/${path}/${state.app.playgroundUniqueId}`;

        if (url) {
            navigator.clipboard.writeText(url);
            toast.success('URL Copied', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }

    }

    const scrappedDataState = useSelector(state => state.scrappedData);


    const dispatch = useDispatch();
    const [domain, setDomain] = useState('');



    const headerfunction = () => {
        return (
            <>
                <button type="button" className="close_btn" data-bs-dismiss="modal" aria-label="Close" >X</button>
            </>
        )
    }


    return (
        <>
            <div className="d-flex justify-content-end top-actionbtton">
                {state.app.playgroundUniqueId &&
                    <div onClick={copyUrl} className='alert alert-primary px-2 py-2 mr-2 copy-btn' style={{ fontSize: 12 }} title='Click to copy'>
                        {domaina}/{path}/{state.app.playgroundUniqueId} <i className='fa fa-copy fa-lg ml-2'></i>

                    </div>
                }
                {state.app.playgroundUniqueId &&
                    <div className="share-button sharer m-1">
                        <button
                            onClick={generateShareUrl}
                            type="button" className="btn btn-secondary share-btn px-4 py-2 topbutton"><i className="fas fa-share-alt"></i> Share</button>
                    </div>
                }
                <div className="save_btn m-1">

                    {state.app.playgroundId ?
                        <>
                            {/* <button
                                disabled={state.app.loading}
                                className="dropdown-toggle btn btn-secondary px-4 py-2 topbutton" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false">
                                <i className="fas fa-bookmark me-1"></i> Save
                            </button> */}

                            <button disabled={state.app.loading} class="dropdown-toggle btn btn-secondary px-4 py-2 topbutton" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false">
                                <i class="fas fa-bookmark me-1"></i> Save
                            </button>
                            <ul className="dropdown-menu">
                                {state.app.playgroundUniqueId !== props.selectedOptionValues ?
                                    <li><a className="dropdown-item" href="#" onClick={() => onSavePlayground('old')}>Overwrite shareable link</a></li>
                                    : ''}
                                <li><a className="dropdown-item" onClick={() => onSavePlayground('new')}>Generate new shareable link</a></li>

                            </ul>
                        </> :
                        <>

                            <button
                                type="button"
                                className="btn btn-secondary px-4 py-2"
                                onClick={() => onSavePlayground('new')}
                                style={{ fontSize: 14 }}
                            >
                                <i className="fas fa-bookmark me-1"></i> Create shareable link
                            </button>
                        </>
                    }

                </div>



                <div className="select_option ms-2 m-1">


                    <div class="select_option ms-2">

                        <select className="form-select select_form mt-1" aria-label="Default select example"
                            onChange={props.handleOptionChange}
                            value={state.app.selectTemplate}

                        >
                            {state.app.selectTemplateList && state.app.selectTemplateList.map((item) => (
                                <option
                                    key={item.id}
                                    value={item.value}
                                    selected={item.selected}
                                >
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    {/* </div> */}
                </div>
            </div>
            {/* <Modal
                show={showAskForModal}
                modalFooter={modalFooter}
                modalBody={modalBody}
                title={modaltitle}
                closeModal={closeModals}
                modalLoader={modalLoader}
                errors={errors}

            /> */}

        </>

    )
}

export default TopActionButtonai